export default "__VITE_ASSET__B3jzXg1O__"